import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import CallUs from '../call-us';

const Pricing = (props: any) => {
  const priceValue = props?.priceValue;
  const title = props?.priceTitle;
  const titleNext = props?.priceData?.Title;
  const parts = titleNext.split('$');
  const tagLine = props?.priceData?.Tag_line;
  const desc = props?.priceData?.Description;
  const imgurl = props?.priceData?.Image?.data?.attributes?.url;
  const { locale } = useRouter();
  return (
    <div className="container-xl custom-container px-0">
      <section>
        <h2 className="section-heading">{title}</h2>
        <div className="sv-portable-storage-pricing">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6 col-md-6 col-12">
                <Image
                  sizes="(max-width: 375px) 250px, (max-width: 576px) 375px, (max-width: 768px) 325px, (max-width: 992px) 430px, (max-width: 1280px) 465px"
                  src={imgurl}
                  className="ps-cubeit-container-img img-fluid"
                  alt={
                    props?.priceData?.Image?.data?.attributes
                      ?.alternativeText ||
                    props?.priceData?.Image?.data?.attributes?.name
                  }
                  width="466"
                  height="357"
                />
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <h6 className="sv-grey-medium-text mt-4 mt-lg-0 mt-md-0">
                  {parts[0]}{' '}
                  <strong>
                    {locale === 'en' && '$'}
                    {priceValue}
                    {locale === 'fr' && ' $'}
                  </strong>{' '}
                  {parts[1]}
                </h6>
                <h5 className="sv-road-grey-para sv-large-font">{tagLine}</h5>
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(desc),
                  }}
                ></div>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <CallUs></CallUs>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <button
                      type="button"
                      className="btn as-secondary-btn ms-lg-2"
                      data-bs-toggle="modal"
                      data-bs-target="#requestCallbackModal"
                    >
                      <FormattedMessage id="callMeBack" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
